const getWalkMeCDNScript = (isProductionEnv, apiKey) => {
    if (!apiKey) return '';
    return `https://cdn.walkme.com/users/${apiKey}/${isProductionEnv ? '' : 'test/'}walkme_${apiKey}_https.js`;
};

export default getWalkMeCDNScript;